import { IPurchasable } from "@smartrr/shared/entities/Purchasable";
import { isSavedByItem } from "@smartrr/shared/utils/containsSavedBy";

/**
 * Checks if a purchasable is a SavedBy (package protection) item
 * SavedBy purchasables are identified by sku or product/variant name containing "savedby" (normalized: lowercase, no spaces)
 * @param purchasable - The purchasable object to check.
 * @returns true if the purchasable is a SavedBy item, false otherwise
 */
export function isSavedByPurchasable(purchasable: IPurchasable): boolean {
  if (isSavedByItem({ productName: purchasable.purchasableName })) {
    return true;
  }
  if (Array.isArray(purchasable.vnts)) {
    return purchasable.vnts.some(variant =>
      isSavedByItem({ sku: variant.sku, variantName: variant.purchasableVariantName })
    );
  }
  return false;
}
